import admin from "./_admin";
import "../../setup/js/_toggleClass";
import "../../setup/js/_scaleRoot.2";
import "../../setup/js/_swiper";
import "../../setup/js/_universalLink";
import "../../setup/js/_scrollwatch";
import "../../setup/js/_vportal";
import scrollFrame from "../../setup/js/_scrollFrame.2";
import scrollWatch from "../../setup/js/_scrollWatch.2";
// import "lazysizes";
// import "@fancyapps/fancybox";

$(document).ready(function () {
  //   $("#wrapper").scalePlatform();
  //   $(window).on("resize", function () {
  //     setTimeout(function () {
  //       $("#wrapper").scalePlatform();
  //     }, 2000);
  //   });
  let $firstImg;
  const isMobile = window.matchMedia(
    "only screen and (max-width: 768px)"
  ).matches;
  if (isMobile) {
    $firstImg = $(".section__background img.mobile").first();
  } else {
    $firstImg = $(".section__background img.desktop").first();
  }
  
  // Function to load video after image is loaded
  function loadVideoAfterImage() {
    $(".loading").removeClass("active");
    $("#wrapper").scalePlatform();
    
    // Load video for desktop
    if (!isMobile) {
      $(".video[data-video]").each(function() {
        const $videoDiv = $(this);
        const videoSrc = $videoDiv.attr("data-video");
        
        if (videoSrc) {
          const videoElement = document.createElement("video");
          videoElement.src = videoSrc;
          videoElement.autoplay = true;
          videoElement.muted = true;
          videoElement.loop = true;
          videoElement.playsInline = true;
          videoElement.style.width = "100%";
          videoElement.style.height = "100%";
          videoElement.style.objectFit = "cover";
          
          // Clear existing content and append video
          $videoDiv.empty().append(videoElement);
        }
      });
    }
  }
  
  // Check if image exists and handle loading
  if ($firstImg.length > 0 && $firstImg[0]) {
    if ($firstImg[0].complete) {
      loadVideoAfterImage();
    } else {
      $firstImg.on("load", function() {
        loadVideoAfterImage();
      });
    }
  } else {
    // If no image found, load video immediately
    loadVideoAfterImage();
  }
  //   $(".loading").each(function () {
  //     setTimeout(() => {
  //       $(".loading").removeClass("active");
  //     }, 2000);
  //   });
});
window.addEventListener("load", function () {

  var url = new URL(window.location.href);
  var param_admin = url.searchParams.get("admin");
  //admin.init();
  admin.executeFunctions();

  $("#wrapper").scalePlatform();
  $(window).on("resize", function () {
    $("#wrapper").scalePlatform();
  });
  commonLibs();

  $("[data-fancybox]").fancybox({
    infobar: false,
    arrows: false,
    keyboard: false,
    touch: false,
    animationEffect: false,
    transitionEffect: false,
    clickSlide: false,
    clickOutside: false,
    smallBtn: false,
    caption: function (instance, item) {
      // console.log($(this).find('figcaption'));
      // return $(this).find('figcaption').html();
    },
    afterLoad: function (instance, current) {
      let popupClassname = current.opts.fancybox;
      instance.current.$content.addClass(popupClassname + "-content");
      instance.current.$content.append(
        "<span data-fancybox-close title='Close' class='close-fancybox'>Close</span>"
      );
      instance.current.$content
        .parents(".fancybox-container")
        .addClass(popupClassname + "-container");
      instance.current.$content
        .parents(".fancybox-inner")
        .addClass(popupClassname + "-inner");
      instance.current.$content
        .parents(".fancybox-stage")
        .addClass(popupClassname + "-stage");
      instance.current.$content
        .parent(".fancybox-slide")
        .addClass(popupClassname + "-slide");
    },
  });
  
});

var commonLibs = function () {
  $("#wrapper").scalePlatform();

  $(".onelink").each(function () {
    $(".onelink").universalLink();
  });

  $("#navBurger").each(function () {
    $("#navBurger").toggleClassname({
      toggle: [
        {
          el: $("#floattop"),
          className: "active",
        },
        {
          el: $("#floatnav"),
          className: "active",
        },
        {
          el: $("#navBurger"),
          className: "is-active",
        },
        {
          el: $("#navBurger"),
          className: "active",
        },
      ],
    });
  });

  $("#subwebBurger").each(function () {
    $("#subwebBurger").toggleClassname({
      toggle: [
        {
      el: $(".midbar__menu"),
          className: "active",
        },
        {
          el: $("#subwebBurger"),
          className: "is-active",
        },
      ],
    });
  });

  $("#asideRightToggle").each(function () {
    $(this).toggleClassname({
      toggle: [
        {
          el: $(".floatright__main"),
          className: "active",
        },
        {
          el: $(".floatright .aside"),
          className: "active",
        },
      ],
    });
  });

  $(".scrollTop").each(function () {
    $(this).on("click", function () {
      $("html, body").animate({ scrollTop: 0 }, 400);
    });
  });

  $(".news").each(function () {
    var postsTag = "#" + $(this).attr("id");
    // console.log(postsTag);
    $().vPortal({
      container: postsTag,
      el: {
        tabContainer: ".news_tab > ul",
        resultContainer: ".news_list",
      },
      paginationOptions: {},
      after: function () {
        $("#wrapper").scalePlatform(); 
      }
    });
  });

  // if ($("[data-lightbox]").length > 0) {
  //     $("[data-lightbox]").each(function () {
  //         $(this).lightBox({
  //             objLightBox: $(this).attr('href'),
  //             type: $(this).data('lightbox-type')
  //         });
  //     });
  // }
};
scrollFrame.init();
scrollWatch.init({
    options: {
        onElementInView: function (e) {
            var $this = $(e.el).parents("[data-block-id]");
            var dataBlockId = $this.attr("data-block-id");

            
            // $(`.nav-left--item[data-fts-selector='data-block-id="${dataBlockId}"']`);
            //$(`[data-fts-selector]`).removeClass("active");
            $(`[data-fts-selector='[data-block-id="${dataBlockId}"]']`).addClass("active");
            $(".menu").removeClass("active");
        }, onElementOutOfView: function (e) {
            var $this = $(e.el).parents("[data-block-id]");
            var dataBlockId = $this.attr("data-block-id");
            //console.log(dataBlockId);
           //$(`[data-fts-selector='[data-block-id="${dataBlockId}"]']`).removeClass("active");
        }
    }
});
var target;
var actIframe = "";
$(".btn-openpopup").on("click", function (e) {
  $("html").addClass("popup-opened");
  target = $(this).data("target");
  $(target).toggleClass("active");
  $("#popup_content iframe").attr("src", "");
  actIframe = $(this).attr("href");
  if (actIframe == "") {
    return false;
  } else {
    $("#popup_content iframe").attr("src", actIframe);
    return false;
  }
  e.preventDefault();
});

